import { BaseNavigationListItem, BaseNavigationListItemProps } from './BaseNavigationListItem';
import { useNavigationListContext } from './useNavigationListContext';
import { Close } from '../UNSAFE_RedwoodIcons/Close';
import { EmbeddedIconButton } from '../PRIVATE_EmbeddedIconButton';
import { useCallback } from 'preact/hooks';
import { useHover } from '#hooks/UNSAFE_useHover';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import type { BundleType } from '../resources/nls/bundle';

type RemovableNavigationListItemProps<K extends string | number> = Omit<
  BaseNavigationListItemProps<K>,
  'removeIcon'
>;

export function RemovableNavigationListItem<K extends string | number>({
  itemKey,
  label,
  badge,
  metadata,
  severity
}: RemovableNavigationListItemProps<K>) {
  const { selection, currentKey, onRemove } = useNavigationListContext();
  const isSelected = selection === itemKey;
  const isCurrent = currentKey === itemKey;

  const handleRemove = useCallback(() => {
    onRemove?.({ value: itemKey as K });
  }, [onRemove, itemKey]);

  const { hoverProps, isHover } = useHover({});

  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');

  //instead of specifying flex: '1 0 auto' in cssProps var
  return (
    <div {...hoverProps}>
      <BaseNavigationListItem
        itemKey={itemKey}
        label={label}
        badge={badge}
        metadata={metadata}
        severity={severity}
        removeIcon={
          <span data-oj-navigationlist-item-remove-icon={true}>
            <EmbeddedIconButton
              aria-label={translations.tabBarNavigationList_removeCueText()}
              size="xs"
              onAction={handleRemove}>
              {(isHover || isSelected || isCurrent) && <Close />}
            </EmbeddedIconButton>
          </span>
        }
      />
    </div>
  );
}
